import { getSearchParams } from './getSearchParams';

export async function getUrlClient() {
  const type = '';
  const link = '';

  const aliasParam = getSearchParams('alias');

  // Pegando a url atual
  const url = window.location.origin;

  // Verificando se a URL é default
  const isDefaultURL =
    url.includes('here') ||
    url.includes('oqdigital') ||
    url.includes('oqvocequer') ||
    url.includes('web.app') ||
    url.includes('indiquecredcrea') ||
    url.includes('indiqueeganhe') ||
    url.includes('indiqueganhe') ||
    url.includes('game') ||
    url.includes('maisjuntos') ||
    url.includes('ganhemais') ||
    url.includes('rendaextra') ||
    url.includes('focoengenharia') ||
    url.includes('localhost') ||
    url.includes('mbrasilconstrutora') ||
    url.includes('firebaseapp') ||
    url.includes('direcional') ||
    url.includes('vivazincorporadora') ||
    url.includes('apaixonadosporcafe') ||
    url.includes('rivaincorporadora') ||
    url.includes('indicauniao') ||
    url.includes('euindico') ||
    url.includes('indiqueeganheeph') ||
    url.includes('fidelidade') ||
    url.includes('indiqueeganhe') ||
    url.includes('indiquepride') ||
    url.includes('indicouyeesganhou') ||
    url.includes('indicamaisarbore') ||
    url.includes('prixconstrutora') ||
    url.includes('indique') ||
    url.includes('vivaquartzo') ||
    url.includes('maccrisconstrutora') ||
    url.includes('rendamaisgrupo') ||
    url.includes('rendamais') ||
    url.includes('indicacaopremiada') ||
    url.includes('parceirovitta') ||
    url.includes('acelera') ||
    url.includes('bomnegocio') ||
    url.includes('lyx') ||
    url.includes('pwvendas') ||
    url.includes('vitalpremia.construtoravital') ||
    url.includes('maismaskan') ||
    url.includes('somosurbvendas.urbvendas');

  if (isDefaultURL) {
    const hasClientAlias = window.location.pathname.includes('/_/');
    const hasClientAliasMGM = window.location.pathname.includes('/_/corretor');

    if (hasClientAliasMGM) {
      const clientAlias = window.location.pathname.replace('/_/corretor/', '');

      localStorage.removeItem('activeDomain');

      return { type: 'clientAlias', link: clientAlias };
    }
    if (hasClientAlias && !hasClientAliasMGM) {
      const clientAlias = window.location.pathname.includes('here')
        ? 'here'
        : window.location.pathname.includes('pwvendas')
          ? 'nos'
          : window.location.pathname.includes('vitalpremia.construtoravital')
            ? 'vital'
            : window.location.pathname.includes('maismaskan')
              ? 'maskan'
              : window.location.pathname.includes('somosurbvendas.urbvendas')
                ? 'neourb'
                : window.location.pathname.replace('/_/', '');

      return { type: 'clientAlias', link: clientAlias };
    }

    if (!hasClientAlias && url.includes('pwvendas')) {
      return { type: 'clientAlias', link: 'nos' };
    }
    if (!hasClientAlias && url.includes('vitalpremia.construtoravital')) {
      return { type: 'clientAlias', link: 'vital' };
    }
    if (!hasClientAlias && url.includes('maismaskan')) {
      return { type: 'clientAlias', link: 'maskan' };
    }
    if (!hasClientAlias && url.includes('somosurbvendas.urbvendas')) {
      return { type: 'clientAlias', link: 'neourb' };
    }

    if (window.location.host === 'here.thereandhere.com.br') {
      return { type: 'clientAlias', link: 'here' };
    }

    if (
      window.location.host === 'indiquecredcrea.com.br' ||
      window.location.host === 'www.indiquecredcrea.com.br'
    ) {
      return { type: 'clientAlias', link: 'credcrea' };
    }
    if (
      window.location.host === 'rendamaisgrupo.direcional.com.br' ||
      window.location.host === 'rendamaisgrupo.direcional.com.br'
    ) {
      return { type: 'clientAlias', link: 'grupodirecional' };
    }
    if (
      window.location.host === 'indicouyeesganhou.com.br' ||
      window.location.host === 'www.indicouyeesganhou.com.br'
    ) {
      return { type: 'clientAlias', link: 'yees' };
    }
    if (window.location.host === 'indiqueeganheeph.com.br') {
      return { type: 'clientAlias', link: 'eph' };
    }
    if (window.location.host === 'indiqueeganhe.casahabita.com.br') {
      return { type: 'clientAlias', link: 'baptistaleal' };
    }
    if (window.location.host === 'indique.maccrisconstrutora.com.br') {
      return { type: 'clientAlias', link: 'maccris' };
    }
    if (window.location.host === 'indicamaisarbore.com.br') {
      return { type: 'clientAlias', link: 'arbore' };
    }
    if (window.location.host === 'euindico.eumedicoresidente.com.br') {
      return { type: 'clientAlias', link: 'emr' };
    }
    if (window.location.host === 'fidelidade.careplusclinic.com.br') {
      return { type: 'clientAlias', link: 'careplusclinic' };
    }
    if (window.location.host === 'indique.prixconstrutora.com.br') {
      return { type: 'clientAlias', link: 'prix' };
    }
    if (window.location.host === 'indiquepride.construtorapride.com.br') {
      return { type: 'clientAlias', link: 'pride' };
    }
    if (window.location.host === 'fidelidade.primeclinic.care') {
      return { type: 'clientAlias', link: 'primeclinic' };
    }
    if (
      window.location.host === 'indicauniao.com.br' ||
      window.location.host === 'www.indicauniao.com.br'
    ) {
      return { type: 'clientAlias', link: 'brconsorcio' };
    }
    if (
      window.location.host === 'indicoucomprouganhou.mbrasilconstrutora.com.br'
    ) {
      return { type: 'clientAlias', link: 'mbrasil' };
    }
    if (
      window.location.host === 'apaixonadosporcafe.com.br' ||
      window.location.host === 'www.apaixonadosporcafe.com.br'
    ) {
      return { type: 'clientAlias', link: 'villa' };
    }
    if (window.location.host === 'rendamais.rivaincorporadora.com.br') {
      return { type: 'clientAlias', link: 'riva' };
    }
    if (window.location.host === 'corretor.vivaquartzo.com.br') {
      return { type: 'clientAlias', link: 'quartzo' };
    }
    if (
      window.location.host === 'game.prestes.com' ||
      window.location.host === 'www.game.prestes.com'
    ) {
      return { type: 'clientAlias', link: 'game3000' };
    }
    if (window.location.host === 'indiqueeganhe.vivaquartzo.com.br') {
      return { type: 'clientAlias', link: 'quartzo' };
    }
    if (window.location.host === 'rendamais.direcional.com.br') {
      return { type: 'clientAlias', link: 'direcional' };
    }
    if (window.location.host === 'indiqueeganhe.catagua.com.br') {
      return { type: 'clientAlias', link: 'catagua' };
    }
    if (
      window.location.host === 'indiqueeganhe.pacaembu.com' ||
      window.location.host === 'www.indiqueeganhe.pacaembu.com'
    ) {
      return { type: 'clientAlias', link: 'pacaembu' };
    }
    if (window.location.host === 'indicaai.focoengenharia.com') {
      return { type: 'clientAlias', link: 'foco' };
    }
    if (window.location.host === 'indiqueeganhe.lyx.com.br') {
      return { type: 'clientAlias', link: 'lyx' };
    }
    if (
      window.location.host === 'maisjuntos.com.br' ||
      window.location.host === 'www.maisjuntos.com.br'
    ) {
      return { type: 'clientAlias', link: 'wanderley' };
    }
    if (
      window.location.host === 'ganhemais.emccamp.com.br' ||
      window.location.host === 'www.ganhemais.emccamp.com.br'
    ) {
      return { type: 'clientAlias', link: 'ganhemais' };
    }
    if (
      window.location.host === 'ganhemais.construtorarivello.com.br' ||
      window.location.host === 'www.ganhemais.construtorarivello.com.br'
    ) {
      return { type: 'clientAlias', link: 'rivello' };
    }
    if (window.location.host === 'rendaextra.adnconstrutora.com.br') {
      return { type: 'clientAlias', link: 'adn' };
    }
    if (window.location.host === 'indiqueganhe.citz.co') {
      return { type: 'clientAlias', link: 'citz' };
    }
    if (window.location.host === 'indiqueeganhe.citz.co') {
      return { type: 'clientAlias', link: 'citz' };
    }
    if (window.location.host === 'indicacaopremiada.vitaurbana.com.br') {
      return { type: 'clientAlias', link: 'vitaurbana' };
    }
    if (window.location.host === 'parceirovitta.com.br') {
      return { type: 'clientAlias', link: 'vittaararaquara' };
    }
    if (window.location.host === 'rendamais.planoeplano.app') {
      return { type: 'clientAlias', link: 'planoeplano' };
    }
    if (window.location.host === 'acelera.mouradubeux.com.br') {
      return { type: 'clientAlias', link: 'md' };
    }
    if (window.location.host === 'indiqueeganhe.meucrescer.com.br') {
      return { type: 'clientAlias', link: 'crescer' };
    }
    if (window.location.host === 'indicacaopremiada.urben.com.br') {
      return { type: 'clientAlias', link: 'urben' };
    }
    if (window.location.host === 'bomnegocio.xyz') {
      return { type: 'clientAlias', link: 'bomnegocio' };
    }
    if (window.location.host === 'pwvendas.com.br') {
      if (!window.location.pathname.includes('/_/')) {
        return { type: 'clientAlias', link: 'nos' };
      }
    }
    if (window.location.host === 'vitalpremia.construtoravital.com') {
      if (!window.location.pathname.includes('/_/')) {
        return { type: 'clientAlias', link: 'vital' };
      }
    }
    if (window.location.host === 'maismaskan.com.br') {
      if (!window.location.pathname.includes('/_/')) {
        return { type: 'clientAlias', link: 'maskan' };
      }
    }
    if (window.location.host === 'somosurbvendas.urbvendas.com.br') {
      if (!window.location.pathname.includes('/_/')) {
        return { type: 'clientAlias', link: 'neourb' };
      }
    }
  }

  if (aliasParam) {
    console.log('tem o alias param');
    return { type: 'clientAlias', link: aliasParam };
  }

  return { type, link };
}
